import React from 'react'
import BasicLink from "./BasicLink";
import { withRouter } from "react-router-dom";
import BasicDetail from "./BasicDetail";

/**
  * @class Basics
  * Show basics
*/
class Basics extends React.Component {

  constructor(props) {
    super(props)
    this.routePage = this.props.match.params.id
    this.state = { currentBasicDetail: 0 }
    this.setBasicDetail = this.setBasicDetail.bind(this)

    /* Static datas */
    this.basics = [
      {
        id: 1,
        name: "Retail",
        route: "/",
        title: "Le retail : notre ADN",
        subtitle: "Notre métier. Notre vocation.",
        content: "<p>Notre agence fait partie du groupe Altavia, premier groupe international \n" +
        "indépendant de communication commerciale dédié au retail.</p>\n" +
        "<p>Présent dans 28 pays, Altavia est, depuis plus de 30 ans, la référence en matière \n" +
        "d’activation commerciale. Marketing 360°, print management, cross-média, gestion de \n" +
        "contenus… Fort de 41 business units et 2 000 collaborateurs, le groupe met son savoir-faire \n" +
        "au service de 300 marques et enseignes, tous secteurs confondus.</p>\n" +
        "<p>Avec Altavia, nous partageons l’envie de proposer des expériences de marque toujours \n" +
        "plus novatrices afin de créer des liens durables entre nos clients et les leurs. </p>",
        picto: "pic-strategie.png",
      },
      {
        id: 2,
        name: "Innovation technologique",
        route: "/innovation-technologique",
        title: "L’innovation technologique : notre culture",
        subtitle: "Anticiper. Innover. Devancer",
        content: "<p>En constante mutation, le monde du retail ne laisse aucune place au hasard. \n" +
        "Les marques ont besoin d’inventivité, d’agilité, de pragmatisme.</p> \n" +
        "<p>Nous nous positionnons en précurseurs. Start-up, partenaires... Nous nous appuyons sur \n" +
        "les nouvelles technologies pour stimuler notre créativité et travailler l’expérience \n" +
        "client de manière innovante.</p> \n" +
        "<p>Pour nourrir notre culture et les solutions à apporter à nos clients, nous nous \n" +
        "appuyons sur les entités Altavia dédiées à l’innovation.</p><br/> \n" +
        "<p><a href='http://www.altavia-coach.com'>alavia-coach.com</a><br/> \n" +
        "<a href='https://www.wetail.com'>wetail.com</a></p>",
        picto: "pic-conception.png",
      },
      {
        id: 3,
        name: "Créativité",
        route: "/creativite",
        title: "La créativité : notre credo",
        subtitle: "Inventer. Se réinventer.",
        content: "<p>Animés par le souci du détail, nous savons que l’idée s’avère la condition sine \n" +
        "qua non pour qu’une marque se différencie, se singularise et génère la préférence... </p>\n" +
        "<p>Que ce soit en BtoB ou en BtoC, notre créativité nous permet d’assurer des réponses \n" +
        "pertinentes à toutes les problématiques de communication, et ce, sans concurrence d’un \n" +
        "média par rapport à un autre</p>",
        picto: "pic-conseil.png",
      },
      {
        id: 4,
        name: "ROI",
        route: "/roi",
        title: "Le retour sur investissement : notre pragmatisme",
        subtitle: "Une belle idée n’est rien sans résultat concret.",
        content: "<p>Notre culture est pragmatique et commerçante. Se fixer et s’aligner sur \n" +
        "des objectifs qualitatifs et quantitatifs nous semble déterminant. Nos actions doivent \n" +
        "servir tout autant votre image que votre business.</p> \n" +
        "<p>Échange, coordination des synergies... Nous vous accompagnons dans l’amélioration de \n" +
        "l’expérience client, le ciblage et le ROI de vos opérations.\n" +
        "De même, nous définissons et mesurons avec vous les KPI moteurs des stratégies de \n" +
        "communication mises en place</p>",
        picto: "pic-innovation.png",
      }
    ]
  }

  componentDidMount() {
    this.basics.some((basic, i) => {
      return (basic.route === "/" + this.routePage) ? this.setBasicDetail(basic.id - 1) : false
    })
  }

  setBasicDetail(basicDetailKey) {
    this.setState({ currentBasicDetail: basicDetailKey })
    this.props.history.push("/agence" + this.basics[basicDetailKey].route)
  }

  getBasicsList() {
    return this.basics.map((basic, i) =>
      <BasicLink key={i} basicDetailKey={i} basicRoute={basic.route} name={basic.name} currentBasicDetail={this.state.currentBasicDetail} setBasicDetail={this.setBasicDetail} />
    )
  }s

  render() {
    return <section className="skills bg--black center-text container-fluid">
      <h2>Nos piliers</h2>
      <ul className="skills__menu"> { this.getBasicsList() } </ul>
      <BasicDetail basic = { this.basics[this.state.currentBasicDetail] } />
    </section>
  }
}

export default withRouter(Basics)




// WEBPACK FOOTER //
// ./src/components/Basics/index.jsx